import { PoweroffOutlined, ReloadOutlined } from '@ant-design/icons'
import { ScreenModel } from '@hmedia/legenda-ds-api-client'
import { Button, Space } from 'antd'
import { FC, useState } from 'react'
import { ContentSelectorModal } from './ContentSelectorModal'
import GateAssignmentModal from './GateAssignmentModal'
import CustomContentPermissionModal from './CustomContentPermissionModal'
import {
  useRenameScreenMutation,
  useScreensQuery,
  useSetContentMutation,
  useUpdateCustomContentPermissionMutation,
  useWakeUpQuery,
} from './queries'
import ScreenItemList from './ScreenItemList'
import { usePermission, Permission } from '../../services/security/permissionContext'

export type Props = {
  pageTitle?: string
}

export const SCREENSVIEW_META: ViewMeta = {
  path: '/',
  title: 'Kijelzők',
}

const ScreensView: FC<Props> = (props) => {
  const screensQuiery = useScreensQuery()
  const [selectedScreen, setSelectedScreen] = useState<ScreenModel>(screensQuiery.data?.[0])
  const renameScreenMutation = useRenameScreenMutation(() => screensQuiery.refetch())
  const [contentSelectorOpened, setcontentSelectorOpened] = useState(false)
  const [gateModalOpen, setGateModalOpen] = useState(false)
  const [selectedScreenForGate, setSelectedScreenForGate] = useState<ScreenModel>()
  const [customContentPermissionModalOpen, setCustomContentPermissionModalOpen] = useState(false)
  const [selectedScreenForCustomContentPermission, setSelectedScreenForCustomContentPermission] = useState<ScreenModel>()
  const contentMutation = useSetContentMutation(() => {
    screensQuiery.refetch()
    setcontentSelectorOpened(false)
  })
  const customContentPermissionMutation = useUpdateCustomContentPermissionMutation(() => {
    screensQuiery.refetch()
  })

  const wakeUpRequest = useWakeUpQuery()
  const isAllowedToAssignGate = usePermission(['SUPERUSER', 'ROLE_ADMIN'])

  function onNameChange(id: string, name: string): void {
    renameScreenMutation.mutate({ id: id, newName: name })
  }

  return (
    <div className="dwadwadwdwa">
      <Space direction="horizontal" align="start" style={{ marginTop: '2rem', width: '100%' }}>
        <h1>Kijelzők</h1>
      </Space>
      <Space direction="vertical" style={{ width: '100%', marginTop: '2em' }} size={20}>
        <Space direction="horizontal" align="start" style={{ width: '100%' }}>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            loading={screensQuiery.isLoading}
            onClick={() => screensQuiery.refetch()}
            size={'large'}
          >
            Kijelzőlista frissítése
          </Button>
          {/* <Button
                        type="default"
                        icon={<PoweroffOutlined />}
                        loading={wakeUpRequest.isLoading}
                        onClick={() => wakeUpRequest.refetch()}
                        size={'large'}
                    >
                        Kijelzők bekapcsolása
                    </Button> */}
        </Space>

        {screensQuiery.data && (
          <ScreenItemList
            onMenuClick={(e) => {
              setSelectedScreen(e)
              setcontentSelectorOpened(true)
            }}
            onGateAssignClick={isAllowedToAssignGate ? (screen) => {
              setSelectedScreenForGate(screen)
              setGateModalOpen(true)
            } : undefined}
            onCustomContentPermissionClick={isAllowedToAssignGate ? (screen) => {
              setSelectedScreenForCustomContentPermission(screen)
              setCustomContentPermissionModalOpen(true)
            } : undefined}
            items={screensQuiery.data}
            onNameChange={onNameChange}
          />
        )}

        {contentSelectorOpened && (
          <ContentSelectorModal
            onContentSelect={(content) =>
              contentMutation.mutate({
                contentType: content.contentType,
                contentId: content.contentId,
                screenId: content.screenId,
              })
            }
            screen={selectedScreen}
            visible={contentSelectorOpened}
            onCancel={(e) => setcontentSelectorOpened(false)}
            onClose={(e) => setcontentSelectorOpened(false)}
          />
        )}

        {gateModalOpen && isAllowedToAssignGate && (
          <GateAssignmentModal
            visible={gateModalOpen}
            screen={selectedScreenForGate}
            onClose={() => {
              setGateModalOpen(false)
              setSelectedScreenForGate(undefined)
            }}
            onSuccess={() => {
              screensQuiery.refetch()
              setGateModalOpen(false)
              setSelectedScreenForGate(undefined)
            }}
          />
        )}

        {customContentPermissionModalOpen && isAllowedToAssignGate && (
          <CustomContentPermissionModal
            visible={customContentPermissionModalOpen}
            screen={selectedScreenForCustomContentPermission}
            onClose={() => {
              setCustomContentPermissionModalOpen(false)
              setSelectedScreenForCustomContentPermission(undefined)
            }}
            onSuccess={() => {
              screensQuiery.refetch()
              setCustomContentPermissionModalOpen(false)
              setSelectedScreenForCustomContentPermission(undefined)
            }}
          />
        )}
      </Space>
      {props.children}
    </div>
  )
}

export default ScreensView
